import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import { formatPrice } from 'helpers/helpers'
import { FormattedMessage } from 'react-intl'
import { useAppSelector } from 'store/hooks'

export const SummaryGiftCardsList = () => {
    const { cart } = useAppSelector((state) => state.cart)
    const { giftCards } = cart || {}

    if (!giftCards || !giftCards.length) return null

    return (
        <Box isFullWidth gap={16} mt={32}>
            <Text variant="heading5" color="secondary_500">
                <FormattedMessage
                    id="vouchers.payment.delivery_cost_label_voucher_applied"
                    defaultMessage="Zastosowany voucher"
                />
            </Text>
            {giftCards.map(({ number, value }) => (
                <Box
                    key={number}
                    direction="row"
                    align="center"
                    gap={8}
                    justify="space-between"
                    isFullWidth
                >
                    <Text variant="bodySmall" color="grayscale_900">
                        {number || '-'}
                    </Text>
                    <Text
                        variant="bodySmall"
                        color="primary_500"
                        style={{ whiteSpace: 'nowrap' }}
                    >
                        {value ? `-\u00A0${formatPrice(value, true)}` : '-'}
                    </Text>
                </Box>
            ))}
        </Box>
    )
}
